import * as React from "react";
import { Card } from "antd";
import { CardContent } from "../../components/antd/card/CardContent";
import { CardTitle } from "../../components/antd/card/CardTitle";
import { BillingAccount, BillingUserRole } from "../../schema/types/account";
import { CpArrayObject } from "../gvc/testNewForm/CpArrayObject";
import { BillingUserInput } from "./create/input";
import { CpArrayItemBillingAccountUser } from "./CpArrayItemBillingAccountUser";
import { v4 as uuidv4 } from "uuid";

interface Props {
  account: BillingAccount;
  users: BillingUserInput[];
  roles: BillingUserRole[];
}
export const Users: React.FC<Props> = ({ users, roles }) => {
  return (
    <>
      <div className="cpln-form-section cpln-ant-card-container">
        <Card>
          <CardTitle>Users</CardTitle>
          <CardContent>
            <div style={{ maxWidth: 900 }}>
              <CpArrayObject
                label="Users"
                labels={["Email", "Roles"]}
                factoryFn={() => ({ id: uuidv4(), email: "", roles: [] })}
                name="users"
              >
                <CpArrayItemBillingAccountUser />
              </CpArrayObject>
            </div>
          </CardContent>
        </Card>
      </div>
    </>
  );
};
